export const selectCurrentUser = (state) => state.authReducer.currentUser?.user;
export const selectUserUuid = (state) => state.authReducer.currentUser?.user?.uuid;
export const selectUserId = (state) => state.authReducer.currentUser?.user?.id;
export const selectUserStats = (state) => state.authReducer.currentUser?.member_app_stats;
export const selectCurrentUserOrganizations = (state) => state.authReducer.currentUser?.organizations;
export const selectCurrentUserLoading = (state) => state.authReducer.loading;
export const selectPhoneConfirmationData = (state) => state.authReducer.phoneConfirmationData;
export const selectPhoneConfirmationCodeSentAttempts = (state) => state.authReducer.phoneConfirmationCodeSentAttempts;
